import React, { useMemo } from "react";

interface Props {
  currentBalance: number
  amount: number
}

const CashWithdrawalPreview: React.FC<Props> = ({
  currentBalance,
  amount
}) => {

  const result = useMemo(() => {
    return currentBalance - amount
  }, [currentBalance, amount])

  return (

    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">

      <div className="border-b border-stroke px-4 py-3 dark:border-strokedark">
        <h3 className="font-medium text-black dark:text-white">
          Impacto del retiro
        </h3>
      </div>

      <div className="p-5">

        <div className="grid grid-cols-3 gap-4 text-center">

          <div>
            <p className="text-sm text-gray-500">Saldo actual</p>
            <p className="mt-1 text-lg font-semibold text-black dark:text-white">
              ${currentBalance.toFixed(2)}
            </p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Retiro</p>

            <span className="inline-flex mt-1 rounded bg-danger px-3 py-1 text-sm font-medium text-white">
              -${amount.toFixed(2)}
            </span>
          </div>

          <div>
            <p className="text-sm text-gray-500">Saldo resultante</p>
            <p className="mt-1 text-xl font-bold text-primary">
              ${result.toFixed(2)}
            </p>
          </div>

        </div>

      </div>

    </div>

  )

}

export default CashWithdrawalPreview